import { environment } from "../../environments/environment";

export default {
  "url": `${environment.url}/api`,
  //"url": 'http://10.14.138.8:3000/emr/api',
  // "url": 'http://localhost:5000/api',
  "MedicalRecord": {
    "GetMedicalRecords": '/MedRecord',
    "GetActiveMedicalRecords": '/MedRecord/Active',
    "GetMedicalRecordDetail": '/MedRecord',
    "SaveMedicalRecordSummary": '/MedRecord/Summary',
    "GetMedicalRecordSummary": '/MedRecord/Summary',
    "GetMedicalRecordDoc": '/MedRecord/Doc',
    //"Approver": 'Approver',
    "MedicalRecord": '/MedRecord',
  },
  "Request": {
    "Manage": '/Request/Manage',
    "History": '/Request/History',
    "Master": '/Request/Master',
    "CreateRequest": '/Request',
    "GetRequestDetail": '/Request',
    "ApproveRequest": '/Request/Approve',
    "RejectRequest": '/Request/Reject',
    "DeleteRequest": '/Request',
    "Request": '/Request'
  },
  "Admin": {
    "UserGroup": '/Admin/UserGroup',
    "User": '/Admin/User',
    "GetUsers": '/Admin/User',
    "GetUserGroups": '/Admin/UserGroup',
    "GetUserGroupDetail": '/Admin/UserGroup',
    "CreateGroup": '/Admin/UserGroup',
    "ApproveRequest": '/Request/Approve',
    "RejectRequest": '/Request/Reject',
    "DeleteRequest": '/Request',
    "UpdateMulti": 'UpdateMulti',
    "Admin": "/Admin",
    "Access": 'Access',
    "UserAccess": 'UserAccess',
  },
  "Authorize": {
    "Login": '/Authorize/Login',
    "Logout": '/Authorize/Logout',
    "DanhSachDoiTuong": '/Authorize/DanhSachDoiTuong',
    "EMRUploadHSRV": '/Authorize/EMRUploadHSRV',
  },
  "GetConfigs": '/MedRecord/Configs',
  "test": '/MedRecord/testcode',
  "Report": {
    "EMRUpload": '/reports/EMRUpload',
    "EMRUploadByRequest": '/reports/EMRUploadByRequest',
  }
}
